import React from 'react';

import styled from 'styled-components';

import useConfigurations from '@hooks/Configurations/UseConfigurations';

import StatementTaxesDetails from '@components/ContactsStatement/StatementTaxesDetails';
import Money from '@components/Gui/Money';

const TotalDetailsContainer = styled.div`
    dl.line-container {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 0;
        line-height: 1.25em;
        padding-top: 0.25rem;

        dt {
            text-transform: uppercase;
            font-weight: 300;
            font-size: ${(props) => props.theme.FontSizeSm};
            color: ${(props) => props.theme.TextColorMuted};
        }

        dd {
            margin: 0;
            min-width: 6.8rem;
        }

        &.last {
            padding-bottom: 0.25rem;
        }
    }

    dl.tax-line-container {
        dt {
            padding-right: 0 !important;
            font-size: ${(props) => props.theme.FontSizeXSm};
        }

        dd {
            min-width: 6.8rem;
        }
    }
`;

const PaymentStatementTotalDetails = ({ statement }) => {
    const configuration = useConfigurations();

    return (
        <TotalDetailsContainer>
            <p>
                <Money redIfNegative amount={statement.AmountDef} currency={configuration.defaultCurrency} />
            </p>
            <StatementTaxesDetails statement={statement} statementCurrency={configuration.defaultCurrency} />
        </TotalDetailsContainer>
    );
};

export default PaymentStatementTotalDetails;
